
{
  "fr": {
    "configuratorGlassSettingsGraduation": {
      "yes": "Avec",
      "no": "Sans",
      "label": "Graduation :"
    }
  }
}
